import { Button, Toolbar } from "@material-ui/core";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link as LinkRouter, useParams } from "react-router-dom";

import { Alert, TimestampCameraMedia } from "@/utilities/types/alert";
import ResolveDialog from "@/views/alerts/AlertsPage/ResolveDialog/ResolveDialog";
import { LiveUnitMosaicPageParams } from "@/views/liveUnitMosaic/LiveUnitMosaicPage";

import { AlertFooter } from "../AlertFooter/AlertFooter";
import useStyles from "./AlertTimelineFooter.styles";


interface FooterProps {
    contextId: string,
    groupedAlertMedia?: TimestampCameraMedia[],
    alert?: Alert,
    setIsLive: (_: boolean) => void;
}

export const AlertTimelineFooter: FC<FooterProps> = ({ contextId, groupedAlertMedia: alertMedia, alert, setIsLive }) => {
    const { t } = useTranslation("translation", { keyPrefix: "components.alerts.alertTimelineFooter" });
    const classes = useStyles();
    const { liveUnitId } = useParams<LiveUnitMosaicPageParams>();
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <Toolbar
            data-testid="alert-timeline-footer"
            className={classes.toolbar}>
            <div className={classes.footerMiddle}>
                {(alertMedia && alertMedia.length !== 0 && alert) &&
                    <AlertFooter
                        alertType={alert.alertType}
                        locationTimezone={alert.locationTimezone}
                        alertMedia={alertMedia} />
                }
                {alert &&
                    <>
                        <Button
                            disabled={alert.state === "resolved"}
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={() => { setOpenDialog(true); }}
                        >
                            {(alert.state === "resolved") ? t("resolved") : t("resolve")}
                        </Button>
                        <ResolveDialog open={openDialog} setOpen={setOpenDialog} alertDetails={alert} />
                    </>
                }
            </div>
            <div className={classes.footerRight}>
                <LinkRouter to={`/live-unit/${liveUnitId}/view?contextId=${contextId}`}>
                    <Button
                        size="large"
                        className={classes.goLive}
                        variant="contained"
                        onClick={() => setIsLive(true)}
                    >
                        {t("goLive")}
                    </Button>
                </LinkRouter>
            </div>
        </Toolbar>
    );
};
